import whatsNew2172 from "@docs/whats-new/v2.17.2.md?raw";
import whatsNew2171 from "@docs/whats-new/v2.17.1.md?raw";
import whatsNew2170 from "@docs/whats-new/v2.17.0.md?raw";
import whatsNew2160 from "@docs/whats-new/v2.16.0.md?raw";
import whatsNew2155 from "@docs/whats-new/v2.15.5.md?raw";
import whatsNew2154 from "@docs/whats-new/v2.15.4.md?raw";
import whatsNew2153 from "@docs/whats-new/v2.15.3.md?raw";
import whatsNew2152 from "@docs/whats-new/v2.15.2.md?raw";
import whatsNew2151 from "@docs/whats-new/v2.15.1.md?raw";
import whatsNew2150 from "@docs/whats-new/v2.15.0.md?raw";
import whatsNew2140 from "@docs/whats-new/v2.14.0.md?raw";
import whatsNew2131 from "@docs/whats-new/v2.13.1.md?raw";
import whatsNew2130 from "@docs/whats-new/v2.13.0.md?raw";
import whatsNew2120 from "@docs/whats-new/v2.12.0.md?raw";
import whatsNew2112 from "@docs/whats-new/v2.11.2.md?raw";
import whatsNew2111 from "@docs/whats-new/v2.11.1.md?raw";
import whatsNew2110 from "@docs/whats-new/v2.11.0.md?raw";
import whatsNew2100 from "@docs/whats-new/v2.10.0.md?raw";
import whatsNew292 from "@docs/whats-new/v2.9.2.md?raw";
import whatsNew291 from "@docs/whats-new/v2.9.1.md?raw";
import whatsNew290 from "@docs/whats-new/v2.9.0.md?raw";
import whatsNew283 from "@docs/whats-new/v2.8.3.md?raw";
import whatsNew282 from "@docs/whats-new/v2.8.2.md?raw";
import whatsNew281 from "@docs/whats-new/v2.8.1.md?raw";
import whatsNew280 from "@docs/whats-new/v2.8.0.md?raw";
import whatsNew272 from "@docs/whats-new/v2.7.2.md?raw";
import whatsNew271 from "@docs/whats-new/v2.7.1.md?raw";
import whatsNew270 from "@docs/whats-new/v2.7.0.md?raw";
import whatsNew260 from "@docs/whats-new/v2.6.0.md?raw";
import whatsNew250 from "@docs/whats-new/v2.5.0.md?raw";
import whatsNew245 from "@docs/whats-new/v2.4.5.md?raw";
import whatsNew244 from "@docs/whats-new/v2.4.4.md?raw";
import whatsNew241 from "@docs/whats-new/v2.4.1.md?raw";
import whatsNew240 from "@docs/whats-new/v2.4.0.md?raw";
import whatsNew230 from "@docs/whats-new/v2.3.0.md?raw";
import whatsNew2211 from "@docs/whats-new/v2.2.11.md?raw";
import whatsNew2210 from "@docs/whats-new/v2.2.10.md?raw";
import whatsNew229 from "@docs/whats-new/v2.2.9.md?raw";
import whatsNew228 from "@docs/whats-new/v2.2.8.md?raw";
import whatsNew227 from "@docs/whats-new/v2.2.7.md?raw";
import whatsNew226 from "@docs/whats-new/v2.2.6.md?raw";
import whatsNew225 from "@docs/whats-new/v2.2.5.md?raw";
import whatsNew224 from "@docs/whats-new/v2.2.4.md?raw";
import whatsNew223 from "@docs/whats-new/v2.2.3.md?raw";
import whatsNew222 from "@docs/whats-new/v2.2.2.md?raw";
import whatsNew221 from "@docs/whats-new/v2.2.1.md?raw";
import whatsNew220 from "@docs/whats-new/v2.2.0.md?raw";
import whatsNew211 from "@docs/whats-new/v2.1.1.md?raw";
import whatsNew210 from "@docs/whats-new/v2.1.0.md?raw";
import whatsNew202 from "@docs/whats-new/v2.0.2.md?raw";
import whatsNew201 from "@docs/whats-new/v2.0.1.md?raw";
import whatsNew200 from "@docs/whats-new/v2.0.0.md?raw";
import whatsNew180 from "@docs/whats-new/v1.8.0.md?raw";
import whatsNew178 from "@docs/whats-new/v1.7.8.md?raw";
import whatsNew177 from "@docs/whats-new/v1.7.7.md?raw";
import whatsNew176 from "@docs/whats-new/v1.7.6.md?raw";
import whatsNew175 from "@docs/whats-new/v1.7.5.md?raw";
import whatsNew174 from "@docs/whats-new/v1.7.4.md?raw";
import whatsNew173 from "@docs/whats-new/v1.7.3.md?raw";
import whatsNew172 from "@docs/whats-new/v1.7.2.md?raw";
import whatsNew171 from "@docs/whats-new/v1.7.1.md?raw";
import whatsNew170 from "@docs/whats-new/v1.7.0.md?raw";
import whatsNew168 from "@docs/whats-new/v1.6.8.md?raw";
import whatsNew167 from "@docs/whats-new/v1.6.7.md?raw";
import whatsNew166 from "@docs/whats-new/v1.6.6.md?raw";
import whatsNew165 from "@docs/whats-new/v1.6.5.md?raw";
import whatsNew164 from "@docs/whats-new/v1.6.4.md?raw";
import whatsNew163 from "@docs/whats-new/v1.6.3.md?raw";
import whatsNew162 from "@docs/whats-new/v1.6.2.md?raw";
import whatsNew161 from "@docs/whats-new/v1.6.1.md?raw";
import whatsNew160 from "@docs/whats-new/v1.6.0.md?raw";
import whatsNew150 from "@docs/whats-new/v1.5.0.md?raw";
import whatsNew148 from "@docs/whats-new/v1.4.8.md?raw";
import whatsNew147 from "@docs/whats-new/v1.4.7.md?raw";
import whatsNew146 from "@docs/whats-new/v1.4.6.md?raw";
import whatsNew145 from "@docs/whats-new/v1.4.5.md?raw";
import whatsNew144 from "@docs/whats-new/v1.4.4.md?raw";
import whatsNew143 from "@docs/whats-new/v1.4.3.md?raw";
import whatsNew142 from "@docs/whats-new/v1.4.2.md?raw";
import whatsNew141 from "@docs/whats-new/v1.4.1.md?raw";
import whatsNew140 from "@docs/whats-new/v1.4.0.md?raw";
import whatsNew131 from "@docs/whats-new/v1.3.1.md?raw";
import whatsNew130 from "@docs/whats-new/v1.3.0.md?raw";
import whatsNew121 from "@docs/whats-new/v1.2.1.md?raw";
import whatsNew120 from "@docs/whats-new/v1.2.0.md?raw";
import whatsNew110 from "@docs/whats-new/v1.1.0.md?raw";
import whatsNew101 from "@docs/whats-new/v1.0.1.md?raw";
import whatsNew100 from "@docs/whats-new/v1.0.0.md?raw";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { MarkdownRenderer } from "@/components/common/markdown-renderer";
import { usePageTitle } from "@/hooks/use-page-title";
import { APP_VERSION } from "@/lib/constants";

// Release history - newest first
const releases = [
  {
    version: "2.17.2",
    title: "SpecTree Toolbox: disregard unposted briefs, editable agendas, confirm guessed values",
    date: "November 2026",
    content: whatsNew2172,
  },
  {
    version: "2.17.1",
    title: "SpecTree Toolbox ADO Formulator: Areas affected only from what the code showed",
    date: "November 2026",
    content: whatsNew2171,
  },
  {
    version: "2.17.0",
    title: "SpecTree Toolbox ADO Formulator: Claude writes the item, findings saved for grooming",
    date: "November 2026",
    content: whatsNew2170,
  },
  {
    version: "2.16.0",
    title: "SpecTree Toolbox: GitHub repositories next to Azure DevOps, steadier Product Q&A verdicts",
    date: "November 2026",
    content: whatsNew2160,
  },
  {
    version: "2.15.5",
    title: "SpecTree Toolbox: Admins add a new ADO project from the project menu",
    date: "November 2026",
    content: whatsNew2155,
  },
  {
    version: "2.15.4",
    title: "Read-only Toolbox groundwork: SpecTree MCP tool list and repository history file",
    date: "November 2026",
    content: whatsNew2154,
  },
  {
    version: "2.15.3",
    title: "SpecTree Toolbox 0.7.0 required: bundled server security fix",
    date: "October 2026",
    content: whatsNew2153,
  },
  {
    version: "2.15.2",
    title: "FogBugz tools polish: priority, tags, paste hint and Q&A hand-off",
    date: "October 2026",
    content: whatsNew2152,
  },
  {
    version: "2.15.1",
    title: "FogBugz to ADO finds the Toolbox app",
    date: "October 2026",
    content: whatsNew2151,
  },
  {
    version: "2.15.0",
    title: "FogBugz Formulator, FogBugz to ADO, Product Q&A and project links",
    date: "October 2026",
    content: whatsNew2150,
  },
  {
    version: "2.14.0",
    title: "FogBugz event log summaries and Look into the code",
    date: "October 2026",
    content: whatsNew2140,
  },
  {
    version: "2.13.1",
    title: "Toolbox fixes for Windows",
    date: "October 2026",
    content: whatsNew2131,
  },
  {
    version: "2.13.0",
    title: "Help in the SpecTree Toolbox",
    date: "October 2026",
    content: whatsNew2130,
  },
  {
    version: "2.12.0",
    title: "PM context on the grooming backlog and Present slides",
    date: "October 2026",
    content: whatsNew2120,
  },
  {
    version: "2.11.2",
    title: "Dependency security fixes",
    date: "October 2026",
    content: whatsNew2112,
  },
  {
    version: "2.11.1",
    title: "Security: Epic Request governance on template epics",
    date: "October 2026",
    content: whatsNew2111,
  },
  {
    version: "2.11.0",
    title: "Security: zod 4 and team checks on every route",
    date: "October 2026",
    content: whatsNew2110,
  },
  {
    version: "2.10.0",
    title: "SpecTree Toolbox for Project Managers",
    date: "October 2026",
    content: whatsNew2100,
  },
  {
    version: "2.9.2",
    title: "Formulator: no more false \"plugin missing\"",
    date: "October 2026",
    content: whatsNew292,
  },
  {
    version: "2.9.1",
    title: "SpecTree Toolbox run queue",
    date: "October 2026",
    content: whatsNew291,
  },
  {
    version: "2.9.0",
    title: "SpecTree Toolbox roles",
    date: "October 2026",
    content: whatsNew290,
  },
  {
    version: "2.8.3",
    title: "Formulator in SpecTree Toolbox",
    date: "October 2026",
    content: whatsNew283,
  },
  {
    version: "2.8.2",
    title: "Board Audit Retired",
    date: "October 2026",
    content: whatsNew282,
  },
  {
    version: "2.8.1",
    title: "SpecTree Toolbox Grooming v2",
    date: "October 2026",
    content: whatsNew281,
  },
  {
    version: "2.8.0",
    title: "SpecTree Toolbox Groundwork",
    date: "October 2026",
    content: whatsNew280,
  },
  {
    version: "2.7.2",
    title: "Board Audit Lists Newest First",
    date: "October 2026",
    content: whatsNew272,
  },
  {
    version: "2.7.1",
    title: "Board Audit Item Details",
    date: "October 2026",
    content: whatsNew271,
  },
  {
    version: "2.7.0",
    title: "Azure DevOps Work Items, Grooming Brief, Documentation Re-audit",
    date: "October 2026",
    content: whatsNew270,
  },
  {
    version: "2.6.0",
    title: "Companion Mod in Claude Code, Plugin Ships With Its Server, Versions in /spectree-status",
    date: "October 2026",
    content: whatsNew260,
  },
  {
    version: "2.5.0",
    title: "SpecTree Becomes a Claude Code Plugin, Git Release Flow Coach, Required Update Notice",
    date: "October 2026",
    content: whatsNew250,
  },
  {
    version: "2.4.5",
    title: "FogBugz Event Log Summaries, Agent Spawn Guard, Skill Pack Update Notice",
    date: "October 2026",
    content: whatsNew245,
  },
  {
    version: "2.4.4",
    title: "In-Repo Precursor Documents, Dependabot Remediation, Shared AGENTS.md, FogBugz Formulator Fixes",
    date: "September 2026",
    content: whatsNew244,
  },
  {
    version: "2.4.1",
    title: "Category-Aware Ticket Interview, Deployment Config Preservation",
    date: "September 2026",
    content: whatsNew241,
  },
  {
    version: "2.4.0",
    title: "FogBugz Formulator, The Three Clocks, Execution Metadata Fix",
    date: "September 2026",
    content: whatsNew240,
  },
  {
    version: "2.3.0",
    title: "Precursor Plan Documents, Inline Request Formulator, Design-Aware Agents",
    date: "September 2026",
    content: whatsNew230,
  },
  {
    version: "2.2.11",
    title: "Model Enforcement Removed, SQLite Retired, Deep-Dive Skill",
    date: "August 2026",
    content: whatsNew2211,
  },
  {
    version: "2.2.10",
    title: "Claude Epic Execute Workflow — Actually Shipped",
    date: "July 2026",
    content: whatsNew2210,
  },
  {
    version: "2.2.9",
    title: "Claude Epic Execute Command Fix",
    date: "July 2026",
    content: whatsNew229,
  },
  {
    version: "2.2.8",
    title: "Unified Claude & Copilot Install, Reliable Epic Execution",
    date: "July 2026",
    content: whatsNew228,
  },
  {
    version: "2.2.7",
    title: "Lean-First MCP Read Policy Hotfix",
    date: "July 2026",
    content: whatsNew227,
  },
  {
    version: "2.2.6",
    title: "Request Formulator Duplicate-Check Hotfix",
    date: "July 2026",
    content: whatsNew226,
  },
  {
    version: "2.2.5",
    title: "Security Remediation & Token Usage Hotfix",
    date: "July 2026",
    content: whatsNew225,
  },
  {
    version: "2.2.4",
    title: "Dashboard Performance, Time-Column Indexes & Observability",
    date: "July 2026",
    content: whatsNew224,
  },
  {
    version: "2.2.3",
    title: "Epic Request Response Shaping & Release Registry Sync",
    date: "July 2026",
    content: whatsNew223,
  },
  {
    version: "2.2.2",
    title: "Lean MCP Responses, Token Efficiency & Copilot/Claude Deployment Hardening",
    date: "July 2026",
    content: whatsNew222,
  },
  {
    version: "2.2.1",
    title: "MCP Delete Operations, Compliance Scoping Fix & CLI Guidance Fix",
    date: "July 2026",
    content: whatsNew221,
  },
  {
    version: "2.2.0",
    title: "Claude Code Readiness (Pending Authorization), Dual-Host Runtime & Safer Tooling",
    date: "June 2026",
    content: whatsNew220,
  },
  {
    version: "2.1.1",
    title: "Recommendation-Ceiling Routing, Team Hierarchy Polish & Release Tooling",
    date: "June 2026",
    content: whatsNew211,
  },
  {
    version: "2.1.0",
    title: "Codex-First Governance, Token Audit Toolkit & MCP Slimming",
    date: "June 2026",
    content: whatsNew210,
  },
  {
    version: "2.0.2",
    title: "Modular Designer Skill, Onboarding UX & Execution Guard Fix",
    date: "May 2026",
    content: whatsNew202,
  },
  {
    version: "2.0.1",
    title: "AI Model Governance, Help Center & Teams Redesign",
    date: "May 2026",
    content: whatsNew201,
  },
  {
    version: "2.0.0",
    title: "Team Hierarchy, Org Migration & Governance",
    date: "May 2026",
    content: whatsNew200,
  },
  {
    version: "1.8.0",
    title: "Dashboard Performance, Skeleton Loading & Error State",
    date: "May 2026",
    content: whatsNew180,
  },
  {
    version: "1.7.8",
    title: "GPT-5.5, PR Skill CI Gate & Literal Newline Fix",
    date: "May 2026",
    content: whatsNew178,
  },
  {
    version: "1.7.7",
    title: "Per-Epic AI Model Recommendation System",
    date: "April 2026",
    content: whatsNew177,
  },
  {
    version: "1.7.6",
    title: "FogBugz Ticket Grouping & Attachment Fixes",
    date: "April 2026",
    content: whatsNew176,
  },
  {
    version: "1.7.5",
    title: "FogBugz Attachment Proxy Fix",
    date: "April 2026",
    content: whatsNew175,
  },
  {
    version: "1.7.4",
    title: "FogBugz Attachments & Inline Images",
    date: "April 2026",
    content: whatsNew174,
  },
  {
    version: "1.7.3",
    title: "FogBugz Ticket List Pagination",
    date: "April 2026",
    content: whatsNew173,
  },
  {
    version: "1.7.2",
    title: "FogBugz Convert-to-ER Copy Box & Infrastructure Fixes",
    date: "April 2026",
    content: whatsNew172,
  },
  {
    version: "1.7.1",
    title: "FogBugz Web Frontend & AI Provider Configuration",
    date: "April 2026",
    content: whatsNew171,
  },
  {
    version: "1.7.0",
    title: "FogBugz Integration & Dual-Provider Database Safety",
    date: "April 2026",
    content: whatsNew170,
  },
  {
    version: "1.6.8",
    title: "Admin Dashboard Enhancements & CSV Export Sync",
    date: "April 2026",
    content: whatsNew168,
  },
  {
    version: "1.6.7",
    title: "Activity Dashboard KPIs & Cross-Codebase Context",
    date: "April 2026",
    content: whatsNew167,
  },
  {
    version: "1.6.6",
    title: "Admin Activity Dashboard & Epic Append Mode",
    date: "April 2026",
    content: whatsNew166,
  },
  {
    version: "1.6.5",
    title: "Simplified Update Skill",
    date: "April 2026",
    content: whatsNew165,
  },
  {
    version: "1.6.4",
    title: "CLI Registry Discovery & Update Fixes",
    date: "April 2026",
    content: whatsNew164,
  },
  {
    version: "1.6.3",
    title: "MCP Skill Pack Update Fix",
    date: "April 2026",
    content: whatsNew163,
  },
  {
    version: "1.6.2",
    title: "Automated PR Review Cycles & CI/CD Fix",
    date: "April 2026",
    content: whatsNew162,
  },
  {
    version: "1.6.1",
    title: "Mark as Implemented, Unified Compliance Scoring & MCP Fix",
    date: "April 2026",
    content: whatsNew161,
  },
  {
    version: "1.6.0",
    title: "Compliance Validation, Epic State Machine & Pagination Overhaul",
    date: "April 2026",
    content: whatsNew160,
  },
  {
    version: "1.5.0",
    title: "Pagination, SSE Updates, Docs-Audit Tool & CLI Registry Sync",
    date: "April 2026",
    content: whatsNew150,
  },
  {
    version: "1.4.8",
    title: "Release Automation, Skill Pack Seeding & CLI Registry Resolution",
    date: "April 2026",
    content: whatsNew148,
  },
  {
    version: "1.4.7",
    title: "Planner Progress Tracking Fix & Epic Requests UI",
    date: "April 2026",
    content: whatsNew147,
  },
  {
    version: "1.4.6",
    title: "Dashboard Fixes & Planner Agent Improvements",
    date: "March 2026",
    content: whatsNew146,
  },
  {
    version: "1.4.5",
    title: "Dashboard Lifecycle Metrics & Planner Progress Tracking",
    date: "March 2026",
    content: whatsNew145,
  },
  {
    version: "1.4.4",
    title: "Admin Visibility, Lifecycle Sessions & Real-Time Overview",
    date: "March 2026",
    content: whatsNew144,
  },
  {
    version: "1.4.3",
    title: "Real-Time Live Updates & Status Animations",
    date: "March 2026",
    content: whatsNew143,
  },
  {
    version: "1.4.2",
    title: "Skill Pack Cleanup Fix",
    date: "March 2026",
    content: whatsNew142,
  },
  {
    version: "1.4.1",
    title: "MCP Skill Pack Tool Fixes",
    date: "March 2026",
    content: whatsNew141,
  },
  {
    version: "1.4.0",
    title: "Team Epic Requests, SSO-Only Auth & Agent Reorganization",
    date: "March 2026",
    content: whatsNew140,
  },
  {
    version: "1.3.1",
    title: "Feature-Level Execution Monitoring",
    date: "March 2026",
    content: whatsNew131,
  },
  {
    version: "1.3.0",
    title: "SSO, Mobile Redesign & Designer Skill",
    date: "March 2026",
    content: whatsNew130,
  },
  {
    version: "1.2.1",
    title: "Unique Identifiers & Accessibility",
    date: "March 2026",
    content: whatsNew121,
  },
  {
    version: "1.2.0",
    title: "Epic Request Creator Self-Approval",
    date: "March 2026",
    content: whatsNew120,
  },
  {
    version: "1.1.0",
    title: "Sprout Chat — AI-Powered Contextual Help",
    date: "March 2026",
    content: whatsNew110,
  },
  {
    version: "1.0.1",
    title: "Epic Request Status Submenu",
    date: "March 2026",
    content: whatsNew101,
  },
  {
    version: "1.0.0",
    title: "Production Release",
    date: "March 2026",
    content: whatsNew100,
  },
];

export function WhatsNewPage() {
  usePageTitle("What's New");
  
  // Current version from build (e.g., "v1.0.1" -> "1.0.1")
  const currentVersion = APP_VERSION.replace(/^v/, "");
  
  return (
    <div className="pt-4 px-4 md:px-0">
      <div className="glass-card rounded-2xl p-4 md:p-6">
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-1 flex-wrap">
            <h1 className="text-lg font-medium">What's New in SpecTree</h1>
            <Badge variant="outline" className="text-xs">{APP_VERSION}</Badge>
          </div>
          <p className="text-muted-foreground text-sm">
            Stay up to date with the latest features and improvements
          </p>
        </div>
        
        <div className="space-y-6">
          {releases.map((release) => (
            <Card key={release.version}>
              <CardHeader className="p-4 md:p-6">
                <div className="flex items-center justify-between flex-wrap gap-2">
                  <div>
                    <CardTitle>Version {release.version}</CardTitle>
                    <CardDescription>{release.title} - {release.date}</CardDescription>
                  </div>
                  {release.version === currentVersion && <Badge>Current</Badge>}
                </div>
              </CardHeader>
              <CardContent className="p-4 md:p-6 pt-0 md:pt-0">
                <MarkdownRenderer content={release.content} />
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
